import React from 'react';
import { Route } from 'react-router-dom';
import PrivateRoute from '../../components/auth/PrivateRoute';
import RequireAdministrationAccess from '../../components/auth/RequireAdministrationAccess';
import { AdministrationLandingPage } from '../lazyComponents';

export function AdministrationRoutes() {
  return (
    <>
      <Route
        path="/administration"
        element={(
          <PrivateRoute>
            <RequireAdministrationAccess>
              <AdministrationLandingPage />
            </RequireAdministrationAccess>
          </PrivateRoute>
        )}
      />
    </>
  );
}
